var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    rx: 8,
    fill: "#1C5E97",
    fillOpacity: 0.22
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 23,
    rx: 7.5,
    stroke: "#1C5E97",
    strokeOpacity: 0.44
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9069 7.03079C13.8825 6.05374 15.4648 6.05314 16.4411 7.02945L17.114 7.70233C18.082 8.67032 18.092 10.2374 17.1365 11.2177L11.846 16.6458C11.1875 17.3214 10.2844 17.7024 9.34132 17.7023L8.5031 17.7023C7.36599 17.7022 6.45789 16.7543 6.50571 15.6174L6.54393 14.7087C6.5808 13.8323 6.94506 13.0017 7.56464 12.3811L12.9069 7.03079ZM15.7345 7.73709C15.1487 7.1513 14.1993 7.15166 13.614 7.73789L13.0111 8.34167L15.8127 11.1432L16.4209 10.5192C16.9942 9.931 16.9882 8.99077 16.4074 8.40998L15.7345 7.73709ZM8.27174 13.0882L12.3046 9.04931L15.1147 11.8594L11.1304 15.9473C10.6601 16.4298 10.015 16.702 9.34137 16.7019L8.50314 16.7019C7.93459 16.7019 7.48054 16.2279 7.50445 15.6594L7.54267 14.7508C7.569 14.1248 7.82919 13.5315 8.27174 13.0882ZM17.9966 17.6541C18.2726 17.6541 18.4964 17.4302 18.4964 17.1539C18.4964 16.8777 18.2726 16.6537 17.9966 16.6537H13.9746C13.6985 16.6537 13.4748 16.8777 13.4748 17.1539C13.4748 17.4302 13.6985 17.6541 13.9746 17.6541H17.9966Z",
    fill: "#1C5E97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.453f7d641eb5367ffefb7d8d93338331.svg";
export { ForwardRef as ReactComponent };